import { render, staticRenderFns } from "./AccountActivate.vue?vue&type=template&id=53325f2c&scoped=true&"
import script from "./AccountActivate.vue?vue&type=script&lang=js&"
export * from "./AccountActivate.vue?vue&type=script&lang=js&"
import style0 from "./AccountActivate.vue?vue&type=style&index=0&id=53325f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53325f2c",
  null
  
)

export default component.exports